export default class Provider {
    constructor({id, name, abbreviation, ispId, tier = 2, links, images, analytics = {}, streamLimiting = {}, countries = [{countryCode: 'US'}] }) {
        this.id = id;
        this.name = name;
        this.abbreviation = abbreviation;
        this.ispId = ispId;
        this.tier = tier;
        this.links = links;
        this.images = images;
        this.analytics = analytics;
        this.streamLimiting = streamLimiting;
        this.countries = countries;
    }

    /**
     * Provider
     * @Param {Object} domesticProvider - A domestic provider from /watch/clients/watchespn-web/providers
     */
    static createProviderDomestic(provider) {
        return new Provider(provider);
    }

    /**
     * Provider
     * @Param {Object} intlProvider - An international affiliate from the intl provider feed
     */
    static createProviderIntl({name, adobeId, analyticsId, ispId, logos: {pickerImage = ''}, websiteUrl, countries = []}) {
        return new Provider({
            id: adobeId,
            name,
            abbreviation: adobeId,
            ispId,
            links: { web: { href: websiteUrl } },
            images: { colorWithPositiveBackground: { href: pickerImage } },
            analytics: { id: analyticsId },
            countries
        })
    }
}



// WEBPACK FOOTER //
// ./app/lib/auth/Provider.js